import { SceneObjects } from '@types'
import { toVector3 } from './conversion/toVector3'
import { degrees } from './generalMaths/geometry'

export const getInitialAngleDegrees = (item: SceneObjects): number => {
  const x = toVector3()
  const y = toVector3()
  const z = toVector3()

  // Extraer las bases de la matriz del item
  item.matrix.extractBasis(x, y, z)

  // Calcular el ángulo de rotación en el eje X
  const xRot = toVector3([1, 0, 0]).angleTo(x)

  // Calcular el producto cruzado
  const crossProduct = toVector3([1, 0, 0]).cross(x)

  // Calcular el ángulo inicial en grados
  const initialAngleDegrees = (degrees(xRot * -Math.sign(crossProduct.y)) + 360) % 360

  return initialAngleDegrees
}
